const pathsRewrittenToNext = ['/', '/l'];
const nextRoute = '/next';
const nextRegExp = new RegExp(`${nextRoute}\\b`);

//TODO: what about /blog? (fully static, next-based, but not from `wren/next`)

export function isPathRenderedByNext(path: string) {
  return pathsRewrittenToNext.includes(path) || nextRegExp.test(path);
}
